import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import useLocation from 'hooks/useLocation';
import { SearchListProducerStyle, SearchGridColumns } from 'components/SearchList/SearchList.css';
import OrganizerCard from 'components/Shared/OrganizerCard/OrganizerCard';
import { createPropsToTrackingMatrix } from 'components/Integration/createPropsToTrackingMatrix';
import { filterParams } from 'components/SearchFilter/filterOptions';
import { ParamsResult } from 'ParamsResult.d';
import { SearchProducer } from 'searchProducers.d';
import { MATRIX_TYPE } from 'constants/index';
import { cardTypeTrackingSearch, typeTrackingSearch } from 'constants/search';

function SearchProducersList({ producers, serviceParams }: { producers: SearchProducer[]; serviceParams: ParamsResult }) {
  const locationStore = useLocation();
  const searchParams = useSearchParams();

  const filters = useMemo(() => {
    const state = Object.entries(filterParams).map(([key, content]) => {
      const queryParam = searchParams?.get(content.name) as string | undefined;

      if (!queryParam) return [key, false];
      return [key, queryParam];
    });

    return Object.fromEntries(state);
  }, [searchParams]);
  return (
    <div className={`${SearchListProducerStyle} ${SearchGridColumns.producersList}`}>
      {producers?.map((producer, idx) => (
        <OrganizerCard
          key={producer.user_id}
          {...producer}
          href={`/produtor/${producer.url}`}
          {...createPropsToTrackingMatrix(idx, {
            type: typeTrackingSearch.organizer,
            trackingPrefix: MATRIX_TYPE.SEARCH,
            matrizTemplate: '',
            componentTemplate: '',
            dataLocation: locationStore.selectedLocation,
            cardType: cardTypeTrackingSearch.eventCardSearch,
            serviceParams,
            payloadCard: producer,
            filters,
          })}
        />
      ))}
    </div>
  );
}

export default SearchProducersList;
